<template>
  <!--<div id="q-app">-->
  <div id="q-app" :class="{ wallpaper: isShowBackgroundImg }">

    <floating-layers />

    <Header />
    <HeaderBar />

    <section class="contentArea">

      <SubHeader/>

      <!--<transition name="el-fade-in-linear">-->
        <keep-alive :exclude="excludeComponentNames">
          <router-view></router-view>
        </keep-alive>
      <!--</transition>-->

      <SubFooter/>

    </section>

    <Footer/>

  </div>
</template>

<script>
  import Header from '../components/Header'
  import HeaderBar from '../components/HeaderBar'
  import Footer from '../components/Footer'
  import SubHeader from '../components/SubHeader'
  import SubFooter from '../components/SubFooter'
  import FloatingLayers from '../components/FloatingLayers'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import { QLayout,QHeader,QDrawer,QScrollArea,QPageContainer,QPage,QToolbar,QToolbarTitle,QDialog,QBtn,QList,QItem,QItemSection,QItemLabel,QExpansionItem,QChip } from 'quasar'
  import { mapGetters } from 'vuex'
  export default {
    name: "DefaultLayout",
    components: {
      Header,
      HeaderBar,
      Footer,
      SubHeader,
      SubFooter,
      FloatingLayers,
      QDialog
    },
    data () {
      return {
        isShowBackgroundImg: true,
        excludeComponentNames: [
          // 'NewsCate',
          // 'ArticleTag',
          // 'ArticleEditor',
          // 'Article',
          // 'Tournament'
          // 'Instagram'
        ]
      }
    },
    watch: {
      'getRoutePath' () {
        this.$nextTick(() => {

          // setTimeout(() => {
          //   //TERA LOG - PC 키설정
          //   window['_LA']=function(){
          //     (window['_LA'].q=window['_LA'].q||[]).push(arguments)
          //   }
          //   window._nSA('CP4B3643229850','ngc1.nsm-corp.com','sa-w.js?',location.protocol,document,window._nSA||{},location.hostname);   //테라 실계정 PC
          //   // window._nSA('TR8703005279','ngc1.nsm-corp.com','sa-w.js?',location.protocol,document,window._nSA||{},location.hostname);   //테라 테스트계정 PC
          // }, 1000)

          //GOOGLE LOG - PC 키설정
          // const page_path = window.location.pathname + window.location.search
          // window.gtag('config', 'UA-88021356-1', {'page_path': page_path})

          this.getDisplayDataFromDB({access: this.getAccess, page: this.getRouteName})
        })
      }
    },
    created() {
      this.getDisplayDataFromDB({access: this.getAccess, page: this.getCurrentComponentName})
      this.getBackgroundImgStatus()
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getDisplayDataFromDB'
      ]),
      getAccess () {
        return 'pc'
      },
      getRoutePath () {
        return this.$route.path + this.$route.params + this.$route.query
      },
      isOpenFooter1Dialog: {
        get () {
          return this.$store.getters.isOpenFooter1Dialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFooter1Dialog', flag)
        }
      },
      isOpenFooter2Dialog: {
        get () {
          return this.$store.getters.isOpenFooter2Dialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFooter2Dialog', flag)
        }
      },
    },
    methods: {
      ...CommonMethods,
      toggleFooter1Dialog (flag) {
        this.$store.dispatch('setOpenFooter1Dialog', flag)
      },
      toggleFooter2Dialog (flag) {
        this.$store.dispatch('setOpenFooter2Dialog', flag)
      },
      getBackgroundImgStatus () {
        this.axios.get('/settings/bg').then(rs => {
          if (rs.data) this.isShowBackgroundImg = JSON.parse(rs.data.is_show_background_img)
        })
      }
    }
  }
</script>

<style scoped>
  .contentArea {
    min-width: unset;
    min-height: 70vh;
    margin: 0 auto;
    position: relative;
    top: 40px;
  }
  .con_hd {
    height: 100px;
    background: #fff;
  }
  .con_hd .con_hd_ad {
    float: right;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
	/deep/ ::-moz-selection{
		background: #00ff64;
		color: #000;
	}
	/deep/ ::selection{
		background: #00ff64;
		color: #000;
	}
  /deep/ .ad_wrap {
    padding: 30px 0;
    text-align: center;
  }
  /deep/ .ad_wrap a {
    padding: 20px 0;
  }
  /deep/ .ad_wrap a img {
    width: 728px !important;
    height: 90px !important;
  }
  /deep/ .layerBackdrop a > img {
    max-width: 320px !important;
  }
  /deep/ .q-carousel {
    background-color: inherit;
  }
  /deep/ p {
    letter-spacing: -0.01em;
  }
	/* on wallpaper */
	#q-app.wallpaper {
		position: relative;
		width: 1300px;
		margin: 130px auto 0;
		background: #fff;
		z-index: 2;
	}
	.wallpaper .contentArea {
		width: 1300px;
		margin: 0 auto;
		background: #fff;
    top: 0;
    padding-top: 40px;
	}
	.hiddenBtn {
		position: fixed;
		left: 0;
		bottom: 0;
		display: inline-block;
		width: 10px;
		height: 10px;
		z-index: 9999;
	}
  #q-app.wallpaper /deep/ .el-input__inner {
    background: #f6f6f6;
  }
</style>
